import { Column, Skeleton, SkeletonBox } from "@hightouch/htui";
import {
  MediaDetailDetails,
  MediaDetailHeaderSkeleton,
  MediaDetailLayout,
  MediaDetailMedia,
  MediaDetailMediaSkeleton,
} from "src/components/media-detail";
import { TilesSkeleton } from "src/pages/ad-studio/insights/tiles-skeleton";

export const AdDrilldownSkeleton = () => (
  <MediaDetailLayout>
    <MediaDetailMedia>
      <MediaDetailMediaSkeleton />
    </MediaDetailMedia>
    <MediaDetailDetails>
      <MediaDetailHeaderSkeleton />
      <Skeleton isLoading>
        <Column gap={6}>
          <TilesSkeleton />
          <SkeletonBox height={60} width="100%" borderRadius="xl" />
        </Column>
      </Skeleton>
    </MediaDetailDetails>
  </MediaDetailLayout>
);
